const R = require('ramda');
import * as cnt from './constants';

const initialState = {
  indexLoading: false,
  indexError: false,
  helpIndex: [],
  contentLoading: false,
  contentError: false,
  helpArticle: undefined,
};

const regExpEscape = s => (s.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&'));
const wildcardToRegExp = s => (new RegExp(`^${s.split(/\*+/).map(regExpEscape).join('.*')}$`));

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case `${cnt.LOAD_HELPFILES}_STARTED`: {
      return Object.assign({}, state, { indexLoading: true });
    }
    case `${cnt.LOAD_HELPFILES}_ERROR`: {
      return Object.assign({}, state, { indexError: false, indexLoading: false });
    }
    case `${cnt.LOAD_HELPFILES}_SUCCESS`: {
      const helpIndex = (payload.items || []).map((e) => {
        return ({
          expressions: (e.fields.matchingUrls || []).map(wildcardToRegExp),
          entryId: e.sys.id,
          matchingRole: (e.fields.matchingRole || []).map(role => role.replace('Buyer', 'Contractor')),
          title: e.fields.title,
        });
      });
      return Object.assign({}, state, { indexError: false, indexLoading: false, helpIndex });
    }
    case `${cnt.LOAD_HELP_ARTICLE}_STARTED`: {
      return Object.assign({}, state, { contentLoading: true });
    }
    case `${cnt.LOAD_HELP_ARTICLE}_ERROR`: {
      return Object.assign({}, state, { contentLoading: false, contentError: true });
    }
    case `${cnt.LOAD_HELP_ARTICLE}_SUCCESS`: {
      const Entry = R.pathOr([], ['includes', 'Entry'], payload);
      const { items: [{ sys: { id: entryId }, fields }] } = payload;

      return Object.assign({}, state, {
        contentLoading: false,
        contentError: false,
        helpArticle: {
          entryId,
          ...fields,
          onThisPage: (fields.onThisPage || []).map(e => ({
            id: e.sys.id,
            ...(Entry.find(include => include.sys.id === e.sys.id).fields || {}),
          })),
        },
      });
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/components/sidebarHelp/reducer.js